export default __webpack_public_path__ + "static/media/53.60d4ec89.png";